import React from "react";
import { Linkedin } from "lucide-react";
import { useContent, FOUNDER_PHOTOS } from "../../cms/ContentContext";
import { FOUNDER_BIOS } from "../../data/content";

// Renders the founding team from CMS content, with photo + graceful initials fallback.
export default function TeamGrid({ variant = "detailed" }) {
  const { content } = useContent();
  const team = content.team || [];

  return (
    <div className={variant === "detailed" ? "grid md:grid-cols-2 gap-5" : "grid grid-cols-2 lg:grid-cols-4 gap-4"}>
      {team.map((m) => {
        const Wrapper = variant === "link" ? "a" : "div";
        const wrapProps = variant === "link" ? { href: m.linkedin, target: "_blank", rel: "noopener noreferrer" } : {};
        return (
          <Wrapper
            key={m.name}
            {...wrapProps}
            className={`card-rise group rounded-lg border border-white/10 bg-navy-900/60 ${variant === "detailed" ? "p-6" : "p-5"} transition-colors ${variant === "link" ? "hover:border-primary/30" : ""}`}
          >
            {variant === "detailed" ? (
              <div className="flex h-full flex-col" data-testid={`team-card-${(m.initials || m.name).toLowerCase()}`}>
                <div className="flex items-center gap-4">
                  <Avatar photo={m.photo || FOUNDER_PHOTOS[m.initials]} initials={m.initials} name={m.name} />
                  <div>
                    <p className="text-base font-semibold text-foreground">{m.name}</p>
                    <p className="text-xs text-primary">{m.role}</p>
                  </div>
                </div>
                {(m.bio || FOUNDER_BIOS[m.initials]) && (
                  <p className="mt-4 text-sm leading-relaxed text-muted-foreground" data-testid="team-card-bio">{m.bio || FOUNDER_BIOS[m.initials]}</p>
                )}
                {m.linkedin && (
                  <a href={m.linkedin} target="_blank" rel="noopener noreferrer" className="mt-auto pt-4 inline-flex items-center gap-1.5 text-sm text-primary hover:underline" data-testid="team-card-linkedin">
                    <Linkedin className="h-4 w-4" /> LinkedIn
                  </a>
                )}
              </div>
            ) : (
              <>
                <Avatar photo={m.photo || FOUNDER_PHOTOS[m.initials]} initials={m.initials} name={m.name} />
                <p className="mt-3 text-sm font-semibold text-foreground">{m.name}</p>
                <p className="text-xs text-muted-foreground">{m.role}</p>
              </>
            )}
          </Wrapper>
        );
      })}
    </div>
  );
}

function Avatar({ photo, initials, name }) {
  const [ok, setOk] = React.useState(true);
  if (photo && ok) {
    return (
      <img
        src={photo}
        alt={name ? `${name}, norse3` : "norse3 team member"}
        loading="lazy"
        onError={() => setOk(false)}
        className="h-16 w-16 rounded-full object-cover ring-1 ring-white/10"
      />
    );
  }
  return (
    <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary/12 text-primary font-heading text-lg font-semibold">
      {initials}
    </span>
  );
}
